import * as React from 'react';
import { UserToken } from '../../amorg-common';
import { AnonymousLayout } from './wrapperLayouts/AnonymousLayout';
import { MemberLayout } from './wrapperLayouts/MemberLayout';
import { UserLayout } from './wrapperLayouts/UserLayout';
import { getMaybeActiveUserOrRefresh, redirectToLogin } from '../../api/serverApiHelpers';
import { PageGuideDefinition } from '../../designSystem/PageGuide';
import { ProtectedPageProvider } from '../_contexts/ProtectedPageContext';
import { Flex } from '../../designSystem/compositeComponents/FlexHelpers';
import { PageTopBarBreadcrumb } from './wrapperLayouts/elements/topBar/TopBar';

type MemberPageWrapperProps = React.PropsWithChildren<{
    allowUser?:boolean
    selectedMenuItemKey?:string,
    hideMenu?:boolean,    
    breadCrumbs?:PageTopBarBreadcrumb[],
    guide?:PageGuideDefinition
}>

export const MemberPageWrapper = (props:MemberPageWrapperProps) => 
{
    const [activeUser, setActiveUser] = React.useState<UserToken | null>(null);

    React.useEffect(() => {
        const handle = async () => {
            const result = await getMaybeActiveUserOrRefresh();
            if(result.tokenUser === null){
                redirectToLogin();
            }
            else{
                setActiveUser(result.tokenUser);
            }
        };
        handle();
    }, []);

    const validPermission = activeUser &&
        (
            (props.allowUser && activeUser.permissionGroupId === 'user') ||
            activeUser.permissionGroupId === 'member' ||
            activeUser.permissionGroupId === 'siteadmin' ||
            activeUser.permissionGroupId === 'superadmin'
        );

    return (
        <>
            {validPermission &&        
                <ProtectedPageProvider 
                    user={activeUser}>

                        {props.hideMenu
                            ? <UserLayout activeUser={activeUser}>
                                {props.children}
                              </UserLayout>
                            : <MemberLayout
                                activeUser={activeUser} 
                                selectedMenuItemKey={props.selectedMenuItemKey}
                                guide={props.guide}
                                breadCrumbs={props.breadCrumbs}>

                                {props.children}

                              </MemberLayout>
                        }

                </ProtectedPageProvider>
            }

            {!validPermission &&
                <AnonymousLayout>

                    <Flex justifyContent='center' alignItems='center'>
                        <p>Hov! Du er havnet på en side, som du ikke har adgang til.</p>
                    </Flex>

                </AnonymousLayout>
            }
        </>
    )    
};